import React from "react";
import { ProductConsumer } from "../../context";

export default function MomsPrice() {
  return (
    <ProductConsumer>
      {(value) => {
        const { cartTax } = value;
        return (
          <div className="row mt-5 mt-lg-0 text-capitalize text-center align.items-center">
            <div className="col-10 mx-4 text-left col-lg-2 pb-2">
              <h6 className="font-weight-bold">Heraf moms</h6>
            </div>
            <div className="col-10 mx-auto col-lg-2 pb-2">
              <p></p>
            </div>
            <div className="col-10 mx-auto col-lg-2 my-2 my-lg-0"></div>
            <div className="col-10 mx-auto col-lg-2 ">
              <strong className="text-muted">{cartTax} kr</strong>
            </div>
          </div>
        );
      }}
    </ProductConsumer>
  );
}
